import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .required('Name is required')
      .trim()
      .min(1, 'Name must be at least 1 character'),
    vslz_id: yup
      .number()
      .nullable()
      .typeError('Visualize ID must be a number'),
    display_name: yup
      .string()
      .required()
      .trim()
      .label('Display Name')
      ,
    home_url: yup
      .string()
      .nullable()
      .trim(),
    vslz_password: yup
      .string()
      .nullable()
      .trim(),
    ais_security_string: yup
      .string()
      .nullable()
      .trim().label('AIS Security String')
  })
  .required()

const resAddCustomer = yupResolver(schema)

export default resAddCustomer
